import { Order, orderStatusConst, orderTags } from './';
import { User } from '@shared-logic/user';

export interface IOrderService {
    editOrderNumber(id: string, field: string, value: any, user: User): Promise<any>;
    // Add other methods if needed
}

export async function saveOrderStatus(order: Order, orderStatus: number, message: string, user: User, service: IOrderService, isMicroservice: boolean = false, logger?: (msg: string) => void): Promise<Order> {
    let orderCopy: Order = JSON.parse(JSON.stringify(order));

    if (orderCopy.statusOrder != orderStatus &&
        orderCopy.statusOrder != orderStatusConst.RETURNED &&
        (orderCopy.statusOrder != orderStatusConst.CONTRACT || isMicroservice)
    ) {
        orderCopy.message = message;
        if (order.message != message && order.message != '') {
            await editOrder(order, orderTags.message, message, user, service);
        }

        orderCopy.statusOrder = orderStatus;
        const statusResult = await editOrder(order, orderTags.statusOrder, orderStatus, user, service);
        logger?.(`statusOrder=${orderStatus}: Error=${JSON.stringify(statusResult.error)}`);

    }
    return orderCopy;
}

export async function editOrder(orderToSave: Order, field: string, value: any, user: User, service: IOrderService) {
    if (field) {
        try {
            return await service.editOrderNumber(orderToSave._id, field, value, user);
        } catch (error) {
            console.error(error);
        }
    }
}
